import * as THREE from "three";
import ExtrudedLoopSubGeometry2d from "../compoundSceneGeometry/ExtrudedLoopSubGeometry2d";
import RectangleAnnotationData from "../sceneObjectData/RectangleAnnotationData";
import { getSceneObjectStyle, getSceneObjectStyleName, SceneObjectStyle, SceneObjectStyleEnum } from "./SceneObjectStyle";

import { LineMaterial } from "three/addons/lines/LineMaterial.js";

export default class RectangleAnnotationGeometry2d extends ExtrudedLoopSubGeometry2d<RectangleAnnotationData> {

    private static lineMaterialCache = new WeakMap<SceneObjectStyle, LineMaterial>();
    private static fillMaterialCache = new WeakMap<SceneObjectStyle, THREE.MeshBasicMaterial>();
    private static textMaterialCache = new WeakMap<SceneObjectStyle, THREE.MeshBasicMaterial>();

    private static getLineMaterial(style: SceneObjectStyle): LineMaterial {
        let mat = RectangleAnnotationGeometry2d.lineMaterialCache.get(style);
        if (!mat) {
            mat = new LineMaterial({
                color: style.color,
                linewidth: style.lineWidth,
                resolution: new THREE.Vector2(window.innerWidth, window.innerHeight),
                depthTest: false
            });
            mat.name = `RectangleAnnotation2d-${getSceneObjectStyleName(style)}-Line`;
            RectangleAnnotationGeometry2d.lineMaterialCache.set(style, mat);
        }
        return mat;
    }

    private static getFillMaterial(style: SceneObjectStyle): THREE.MeshBasicMaterial {
        let mat = RectangleAnnotationGeometry2d.fillMaterialCache.get(style);
        if (!mat) {
            mat = new THREE.MeshBasicMaterial({ color: style.color, transparent: true, opacity: 0.35, depthTest: false, side: THREE.DoubleSide });
            mat.name = `RectangleAnnotation2d-${getSceneObjectStyleName(style)}-Fill`;
            RectangleAnnotationGeometry2d.fillMaterialCache.set(style, mat);
        }
        return mat;
    }

    private static getTextMaterial(style: SceneObjectStyle): THREE.MeshBasicMaterial {
        let mat = RectangleAnnotationGeometry2d.textMaterialCache.get(style);
        if (!mat) {
            mat = new THREE.MeshBasicMaterial({ color: style.color });
            mat.name = `RectangleAnnotation2d-${getSceneObjectStyleName(style)}-Text`;
            RectangleAnnotationGeometry2d.textMaterialCache.set(style, mat);
        }
        return mat;
    }

    constructor() {
        super(
            RectangleAnnotationGeometry2d.getLineMaterial(getSceneObjectStyle(SceneObjectStyleEnum.Normal)),
            RectangleAnnotationGeometry2d.getFillMaterial(getSceneObjectStyle(SceneObjectStyleEnum.Normal)),
            RectangleAnnotationGeometry2d.getTextMaterial(getSceneObjectStyle(SceneObjectStyleEnum.Normal))
        );
    }

    protected getLineMaterialForStyle(style: SceneObjectStyle): LineMaterial {
        return RectangleAnnotationGeometry2d.getLineMaterial(style);
    }

    protected getFillMaterialForStyle(style: SceneObjectStyle): THREE.MeshBasicMaterial {
        return RectangleAnnotationGeometry2d.getFillMaterial(style);
    }

    protected getTextMaterialForStyle(style: SceneObjectStyle): THREE.MeshBasicMaterial {
        return RectangleAnnotationGeometry2d.getTextMaterial(style);
    }
}
